import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
export default MuiThemeProvider;
